/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { Tooltip } from 'primereact/tooltip';
import { MessageDetail } from '../../utils/types'
import './messageDetails.scss'

interface NotificationDetailProps {
    notification: MessageDetail
    onSelect: (notification: MessageDetail) => void
}

export const MessageDetails = (props: NotificationDetailProps) => {
    const handleSelect: (event: any, notification: MessageDetail) => void = (event, notification) => {
        event.preventDefault();
        props.onSelect(notification)
    };
    const returnSubject = () => {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-to-interactive-role
            /* eslint-disable */
            <span role='button' onClick={(e: any) => { handleSelect(e, props.notification) }} className='subject font-weight-bolder font-size-24 margin-left-10'>{props.notification.template_subject}</span>
        )
    }
    return (
        <div className='margin-top-10'>
            <i className="pi pi-envelope font-size-20" /> {returnSubject()}
            <Tooltip target=".body-text" mouseTrack mouseTrackLeft={10} />
            <p><span className="body-text" data-pr-tooltip ={props.notification.template_body}>{props.notification.template_body}</span></p>
        </div>
    )
}